import TransactionAction from '../cardActions/TransactionAction';
import * as Adaptive from 'adaptivecards';
import {
    CardDetails,
    ExecuteActionResponse,
    MessageContext,
    TelemetryProvider,
    ElementDetails,
} from 'owa-actionable-message';
import { trace } from 'owa-trace';
import showOPayPanel from '../actions/showOPayPanel';
import { TRANSACTION_ACTION_CLICKED, ACTION_CONTEXT } from '../constants';

export default function executeAction(
    action: Adaptive.Action,
    cardDetails: CardDetails,
    inputs: Adaptive.Input[],
    handleActionResponse: (response: ExecuteActionResponse) => void,
    messageContext: MessageContext,
    telemetryProvider: TelemetryProvider,
    isAutoInvokeAction: boolean
): boolean {
    if (action instanceof TransactionAction) {
        trace.info('[ActionableMessageDebug] Transaction executed');
        const transactionAction: TransactionAction = action as TransactionAction;
        const elementDetails: ElementDetails = {
            id: transactionAction.id,
            type: transactionAction.getJsonTypeName(),
        };
        telemetryProvider.logTelemetry({
            cardDetails: cardDetails,
            elementDetails: elementDetails,
            eventName: TRANSACTION_ACTION_CLICKED,
            actionContext: action[ACTION_CONTEXT],
            messageContext: messageContext,
        });
        showOPayPanel(transactionAction.getIFrameElement());
    } else {
        return false;
    }

    return true;
}
